"use client";

import { Link, redirect, useRouter } from "@/i18n/navigation";
import { useLocale, useTranslations } from "next-intl"
import CreditCard from "@/components/icons/credit-card.svg"
import { useAppDispatch, useAppSelector } from "@/lib/client/storeHooks";
import { Order } from "@/../comatic/lib/types";
import { clear as clearCart } from "@/lib/client/cartSlice";

interface CartSubmitProps {
  lockUi?: boolean;
  setLockUi?: (s: boolean) => void;
}

export default function CartSubmit(props: CartSubmitProps) {
  const router = useRouter();
  const t = useTranslations('Cart');
  const cart = useAppSelector(s => s.cart);
  const cartDeliveryAddress = useAppSelector(s => s.cart.currentDeliveryAddressId);
  const user = useAppSelector(s => s.session.user);
  const appDispatch = useAppDispatch();
  const locale = useLocale();

  const onSubmitClick = async () => {
    if (!user) {
      router.push('/kundenkonto/login?continue=' + encodeURIComponent('/warenkorb'), { locale });
      return;
    }

    if (props.setLockUi) props.setLockUi(true);
    let submitRes = await fetch('/api/cart/order', {
      method: 'POST'
    });

    if (submitRes.ok) {
      let resBody: { order: Order, nextUrl: string } = await submitRes.json();

      appDispatch(clearCart());

      router.push(resBody.nextUrl, { locale });
    } else {
      if (props.setLockUi) props.setLockUi(false);
    }
  }

  return (
    <div className="w-full flex flex-col gap-y-[30px]">
      <div className="w-full px-4 text-sm">
        {t('cart-filed-submit-conditions1')}
        <Link href="/agb" className="cursor-pointer underline">{t('cart-filed-submit-conditions-t-and-c')}</Link>
        {t('cart-filed-submit-conditions2')}
        <Link href="/datenschutz" className="cursor-pointer underline">{t('cart-filed-submit-conditions-pp')}</Link>
        {t('cart-filed-submit-conditions3')}
      </div>
      <div className="w-full flex flex-col items-center">
        <button className="btn btn-secondary text-white rounded-full w-[180px]" onClick={onSubmitClick} {...(props.lockUi || (user && user.id && (!cartDeliveryAddress || cartDeliveryAddress == -1)) ? { disabled: true } : {})}>
          <CreditCard height={14} width={14} />
          {t('cart-field-submit')}
        </button>
      </div>
    </div>
  )
}
